class mPlpHero extends HTMLDivElement {
    constructor() {
        super();
        this.oNavigation = document.querySelector('[is="o-navigation"]');
    }

    connectedCallback() {
        if (this.oNavigation && 'allowTransparency' in this.oNavigation.dataset) {
            this.oNavigation.setAttribute('data-is-transparent', true);
        }
    }

}

customElements.define('m-plp-hero', mPlpHero, {
    extends: 'div'
});
